import React from 'react';
import { classNames } from '@pwskills/rachnaui/utils';
import { IIcon } from '../Icons.types';

const Presentation = (props: IIcon) => {
  const { className = '', ...rest } = props;
  return (
    <svg
      {...rest}
      className={classNames(className)}
      xmlns="http://www.w3.org/2000/svg"
      width={61}
      height={60}
      viewBox="0 0 61 60"
      fill="none"
    >
      <g clipPath="url(#clip0_419_6080)">
        <path
          d="M60.5 30C60.5 13.4315 47.0685 0 30.5 0C13.9315 0 0.5 13.4315 0.5 30C0.5 46.5685 13.9315 60 30.5 60C47.0685 60 60.5 46.5685 60.5 30Z"
          fill="#FEF1F2"
        />
        <path
          d="M34.9448 39.9998L33.834 35.5557"
          stroke="#F5808B"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.0547 39.9998L27.1655 35.5557"
          stroke="#F5808B"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.1942 35.5558H22.8058C22.1943 35.5558 21.6078 35.3129 21.1754 34.8805C20.7429 34.448 20.5 33.8615 20.5 33.25V22.3058C20.5 21.6943 20.7429 21.1078 21.1754 20.6754C21.6078 20.2429 22.1943 20 22.8058 20H38.1933C38.4962 19.9999 38.7961 20.0595 39.076 20.1753C39.3559 20.2911 39.6101 20.4609 39.8243 20.6751C40.0385 20.8892 40.2085 21.1434 40.3244 21.4232C40.4403 21.703 40.5 22.003 40.5 22.3058V33.25C40.5 33.8615 40.2571 34.448 39.8246 34.8805C39.3922 35.3129 38.8057 35.5558 38.1942 35.5558Z"
          stroke="#F5808B"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.5 31.1105V28.083"
          stroke="#F5808B"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.834 31.111V24.4443"
          stroke="#F5808B"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.166 31.1102V27.416"
          stroke="#F5808B"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.5 31.1108V25.0508"
          stroke="#F5808B"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_419_6080">
          <rect width={60} height={60} fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Presentation;
